import { DesignTokens, GivelifyButton, GivelifyModal } from '@givelify/ui';
import { Grid, styled } from '@mui/material';

export const StyledModal = styled(GivelifyModal)(() => ({
    '& .MuiPaper-root': {
        width: '540px',
        padding: 0,
        background: '#fff',
    },
}));

export const CloseButton = styled(GivelifyButton)(() => ({
    width: '32px',
    position: 'absolute',
    right: '20px',
    top: '20px',
}));

export const ModalHeader = styled('div')(({theme}) => ({
    textAlign: 'center',
    padding: '32px 0 12px 0',
    background: '#fff',
    '&.no-results': {
        [theme.breakpoints.down('mobile')]: {
            padding: '42px 48px 12px 48px',
        }
    }
}));

export const ModalContent = styled('div')(() => ({
    borderBottom: `1px solid ${DesignTokens.color.dividerPrimaryLight}`,
    borderTop: `1px solid ${DesignTokens.color.dividerPrimaryLight}`,
    marginBottom: '32px',
    maxHeight: '340px',
    overflow: 'auto',
    '&.no-results': {
        border: 'none',
        marginBottom: '24px',
        padding: '12px',
    },
}));

export const ModalFooter = styled('div')(({theme}) => ({
    textAlign: 'center',
    paddingBottom: '32px',
    background: '#fff',
    '& .link': {
        fontSize: '16px',
    },

    '&.no-results': {
        padding: '0 120px 48px 120px',

        '& .next': {
            marginTop: '32px',
        },
        [theme.breakpoints.down('mobile')]: {
            padding: '0 24px 48px 24px',
        }
    },
}));

export const SuggestionWrapper = styled(Grid)(({ theme }) => ({
    padding: '16px 40px',
    flexWrap: 'nowrap',
    cursor: 'default',
    '& .select': {
        borderColor: DesignTokens.color.chartGrey200,
        color: DesignTokens.color.textPrimary,
    },
    background: '#fff',
    '&:hover': {
        background: DesignTokens.color.backgroundPrimary,
    },

    [theme.breakpoints.down('mobile')]: {
        padding: '16px',

        '& .select': {
            maxWidth: '84px',
        },
    },
}));

export const CardWrapper = styled('div')(() => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
}));

export const OrganizationCard = styled('div')(() => ({
    borderRadius: '16px',
    background: '#FFF',
    boxShadow: DesignTokens.shadow.shadowMediumLow,
    width: '300px',
    overflow: 'hidden',
    paddingBottom: '12px',
    '& .background': {
        width: '100%',
        height: '140px',
        background: DesignTokens.color.globalGuidingViolet100,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
    },
    '& .content': {
        padding: '24px',
    },
}));
